import { createClient } from '@supabase/supabase-js'

// Configuration Supabase (Vue CLI utilise process.env.VUE_APP_)
const supabaseUrl = process.env.VUE_APP_SUPABASE_URL || 'https://mcycsmcjxdkomnfynjgn.supabase.co'
const supabaseAnonKey = process.env.VUE_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1jeWNzbWNqeGRrb21uZnluamduIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjA2MTgxNzEsImV4cCI6MjA3NjE5NDE3MX0.ndjOLhPcwxmkISZT-io25A5uduMMptkIkvX2rAlEhNA'

// Options optimisées pour de meilleures performances
const options = {
  auth: {
    // Session Supabase Auth conservée et rafraîchie pour l'espace admin
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false
  },
  global: {
    headers: {
      'x-client-info': 'portfolio-vue'
    }
  },
  // Réutilisation des connexions HTTP
  realtime: {
    enabled: false // Désactiver si vous n'utilisez pas les fonctionnalités temps réel
  }
}

// Créer le client Supabase
export const supabase = createClient(supabaseUrl, supabaseAnonKey, options)

